export const FIELDS = {

  ID: 'id',
  NAME: 'name',
  SYMBOL: 'symbol',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
};